<template lang="pug">
  section.front(v-if="sets.length > 0",:class="{preview: preview}")
    div.floor(:style="styFloor()")
      div.area
        Space
        div.area-inr(:style="area()")
          <!--SizeWidth(@change="WdChange")-->
          SizeHeight(@change="HtChange")
          ScaleFloor
          Rails
          Slits
          Items
          SlitsPreview(v-if="preview === true")
      Vertical
    div.underfloor
      div.inner(:style="sty()")
        ScaleUnderfloor
        Horizontal
      Position
</template>

<script>
import Vertical from './Vertical.vue';
import Horizontal from './Horizontal.vue';
import ScaleFloor from './ScaleFloor.vue';
import ScaleUnderfloor from './ScaleUnderfloor.vue';
import SizeWidth from './SizeWidth.vue';
import SizeHeight from './SizeHeight.vue';
import Slits from './Slits.vue';
import SlitsPreview from './SlitsPreview.vue';
import Rails from './Rails.vue';
import Items from './Items.vue';
import Space from './Space.vue';
import Position from './Position.vue';

export default {
  name: 'Front',
  components: {
    ScaleFloor,
    ScaleUnderfloor,
    SizeWidth,
    SizeHeight,
    Slits,
    SlitsPreview,
    Rails,
    Items,
    Space,
    Horizontal,
    Position,
    Vertical
  },
  data () {
    return {
      timer: {},
      left: 0,
      width: 450,
      height: 700,
      bottom: 0,
      set: {}
    };
  },
  computed: {
  },
  watch: {
    number () {
      this.update();
    },
    sets () {
      this.update();
    },
    view () {
      this.update();
    }
  },
  methods: {
    update () {
      let me = this;
      me.set = me.sets[me.number];
      // すべて更新
      if (me.sets.length > 0 && me.set !== undefined) {
        me.width = me.set.size[0];
        me.height = me.set.size[1];
        me.bottom = me.c2p(me.set.size[3]);
        me.left = me.c2p(me.set.left);
      }
      clearTimeout(me.timer);
      me.timer = setTimeout(function () {
        if (me.$el !== undefined) {
          if (me.$el.querySelector) {
            let underfloor = me.$el.querySelector('.underfloor').offsetHeight;
            let clientRect = me.$el.querySelector('.area-inr').getBoundingClientRect();
            let px = window.pageXOffset + clientRect.right;
            me.$el.style.minWidth = px + 'px';

            if (me.set !== undefined) {
              let py = (window.pageXOffset + clientRect.bottom) - (window.pageXOffset + clientRect.top) + underfloor + me.c2p(me.set.size[3]) + 200;
              me.$el.style.minHeight = py + 'px';
            }
          }
        }
      }, 500);
    },
    WdChange (mm) {
      // 横幅を変えた時
      this.set.size.splice(0, 1, mm);
      this.set.slits[this.set.slits.length - 1].pos = mm;
      this.sets.splice(this.number, 1, this.set);
    },
    HtChange (mm) {
      // 高さを変えた時
      this.set.size.splice(1, 1, mm);
      this.updateSlit(this.set);
      this.sets.splice(this.number, 1, this.set);
    },
    area () {
      return {
        left: (this.left) + 'px',
        width: (this.c2p(this.width)) + 'px',
        height: (this.c2p(this.height)) + 'px',
        bottom: this.bottom + 'px'
      };
    },
    sty () {
      return {
        left: (this.left + 100) + 'px'
      };
    },
    styFloor () {
      return {
        backgroundPosition: 'left ' + this.left + 'px bottom'
      };
    }
  },
  created () {
    this.update();
  }
};
</script>

<style lang="stylus" scoped>
  .front
    position absolute
    left 0
    right 0
    top 0
    bottom 0
    min-width 1000px
    min-height 760px
    overflow hidden
    background-color #efefef
    &.preview
      top auto
  .floor
    position absolute
    left 0
    right 0
    top 0
    bottom 86px
    z-index 1
    background url("../../assets/bg_grid.svg") 0 bottom
  .area
    position absolute
    left 100px
    right 0
    top 0
    bottom 0
    z-index 1
    .area-inr
      position absolute
      left 0
      bottom 0
  .underfloor
    position absolute
    z-index 1
    left 0
    right 0
    bottom 0
    height 86px
    background-color #D9CE9C
    .inner
      position absolute
      left 100px
      top 0
</style>



// WEBPACK FOOTER //
// src/components/front/Front.vue